import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAdr } from '../models/adr.model';
import { environment } from '../../../environments/environment';
import { InlineResponse } from '../models/inline-response.model';
import { Adr } from '../../features/parameters/referentials/referentials-adr/adr.model';

const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class AdrClientService {
  private apiURL = environment.apiURL;

  private serviceUrl = this.apiURL + '/services/adr';

  constructor(private http: HttpClient) {}

  public getAdrData(): Observable<IAdr> {
    return this.http.get<IAdr>(this.serviceUrl);
  }

  public getAdrDataById(id: number): Observable<IAdr> {
    return this.http.get<IAdr>(this.serviceUrl + `/${id}`);
  }

  public addAdrData(classe: string, codeDanger: string, codeHecate: number, codeTunnels: string, designation: string, groupeEmballage: string, numeroUN: number): Observable<InlineResponse> {
    let params = new HttpParams().set('classe', classe).set('codeDanger', codeDanger).set('codeHecate', codeHecate.toString()).set('codeTunnels', codeTunnels).set('designation', designation).set('groupeEmballage', groupeEmballage).set('id', '').set('numeroUN', numeroUN).set('oper', 'add');

    console.log(params);

    return this.http.post<InlineResponse>(this.serviceUrl, params, options);
  }

  public updateAdrData(adr: Adr): Observable<InlineResponse> {
    let params = new HttpParams()
      .set('classe', adr.classe)
      .set('codeDanger', adr.codeDanger)
      .set('codeHecate', adr.codeHecate)
      .set('codeTunnels', adr.codeTunnels)
      .set('designation', adr.designation)
      .set('groupeEmballage', adr.groupeEmballage)
      .set('id', adr.id)
      .set('numeroUN', adr.numeroUN)
      .set('oper', 'edit');

    console.log(params);

    return this.http.post<InlineResponse>(this.serviceUrl, params, options);
  }
}
